import Image from "next/image";
import lightIcon from "../../public/images/about/sun-01.svg";
import darkIcon from "../../public/images/about/vector.svg";

const DarkSwitch = ({ isLight, switchTheme }) => {
  return (

    <button
      onClick={switchTheme}
      className={`btn btn-light shadow-sm d-flex align-items-center justify-content-center p-2 rounded-circle 
                  ${isLight ? 'text-dark bg-white' : 'text-primary bg-black'}`}
      aria-label={`Switch to ${isLight ? "Dark Mode" : "Light Mode"}`}
      style={{
        width: "40px",
        height: "40px",
        border: "1px solid rgba(0,0,0,0.1)",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <Image
        src={isLight ? darkIcon : lightIcon}
        alt={isLight ? "Dark mode icon" : "Light mode icon"}
        width={20}
        height={20}
        className="object-contain"
      />
    </button>
  );
};

export default DarkSwitch;
